/* unplugin-vue-components disabled */import script from "./PackageList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackageList.vue?vue&type=script&lang=ts&setup=true"

import "./PackageList.vue?vue&type=style&index=0&id=b2c5380c&lang=less&scoped=true"

import exportComponent from "/layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2c5380c"]])

export default __exports__